import { html } from 'lit';
import { CallToActionProps } from './call-to-action.types';
import { Icon } from './icon';
import { getTarget } from '../../utilities/get-target';

export const CallToAction = ({
  theme = 'light',
  type = 'secondary',
  size,
  linkText = 'Learn more',
  ariaLabel = 'Learn more about lorem ipsum dolor si',
  showIcon,
  iconType,
  showPlainText,
  href = '/',
  openInNewTab,
  targetTopWindow,
}: CallToActionProps) => {
  const target = getTarget(targetTopWindow, openInNewTab);

  return html`
    <umd-element-call-to-action
      slot="actions"
      data-display="${type}"
      data-visual-size="${size}"
      data-theme="${theme}"
    >
      <a href="${href}" aria-label="${ariaLabel}" target="${target}">
        ${linkText} ${showIcon && iconType ? Icon(iconType) : ''}
      </a>
      ${showPlainText ? html`<a href="/" slot="text">Plain Text</a>` : ''}
    </umd-element-call-to-action>
  `;
};
